/* istanbul ignore file */
import React, { useState, ReactElement, useContext, useEffect } from "react";
import RapportageSelect from "./rapportage-select";
import RapportageData from "./rapportage-data";
import { AppDataContext } from "../navigation/appdata-context";

export const RapportageWrapper = (): ReactElement => {
  const { menuInfo: { voorstellen } } = useContext(AppDataContext);
  
  let initialSelection = "Huidig";
  if(voorstellen && voorstellen?.length > 0) {
    initialSelection = voorstellen[0].id
  } 

  const [selectedVoorstel, setSelectedVoorstel] = useState<string>(initialSelection || "Huidig");
  const [selectEnabled, setSelectEnabled] = useState<boolean>(true);

  useEffect(() => {
    // console.log(voorstellen);
  } , []);

  return (
    <div className="p-4">
        <RapportageSelect
          setSelectedVoorstel={setSelectedVoorstel}
          selectedVoorstel={selectedVoorstel}
          isDirty={selectEnabled}
        />
      <RapportageData voorstel={selectedVoorstel} setIsDirty={setSelectEnabled} />
    </div>
  );
};

export default RapportageWrapper;
